import { render } from "./ShareView.vue?vue&type=template&id=4f437b98&scoped=true"
import script from "./ShareView.vue?vue&type=script&lang=js"
export * from "./ShareView.vue?vue&type=script&lang=js"

import "./ShareView.vue?vue&type=style&index=0&id=4f437b98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f437b98"]])

export default __exports__